/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VisitorChartDataDto } from '../../models/visitor-chart-data-dto';

export interface VisitorAdminControllerGetIncomingPageV1$Params {

/**
 * 시작일
 */
  startAt?: string;

/**
 * 종료일
 */
  endAt?: string;

/**
 * 검색 타입
 */
  type?: string;
}

export function visitorAdminControllerGetIncomingPageV1(http: HttpClient, rootUrl: string, params?: VisitorAdminControllerGetIncomingPageV1$Params, context?: HttpContext): Observable<StrictHttpResponse<VisitorChartDataDto>> {
  const rb = new RequestBuilder(rootUrl, visitorAdminControllerGetIncomingPageV1.PATH, 'get');
  if (params) {
    rb.query('startAt', params.startAt, {});
    rb.query('endAt', params.endAt, {});
    rb.query('type', params.type, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VisitorChartDataDto>;
    })
  );
}

visitorAdminControllerGetIncomingPageV1.PATH = '/api/v1/visitors/admin/incoming-page';
